"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SingleStudents = void 0;
var _SingleStudents = require("./SingleStudents.styles");
var _hooks = require("../../../../../hooks");
var _AudiencePicker = require("../../../AudiencePicker.labels");
var _Modal = require("../../../../../Layout/Modal");
var _SelectedAudience = require("../SelectedAudience");
var _ExpandableButton = require("../../../../../UI/ExpandableButton");
var _Input = require("../../../../../UI/Input");
var _Tooltip = require("../../../../../UI/Tooltip");
var _Select = require("../../../../../UI/Select");
var _Icon = require("../../../../../UI/Icon");
var _Button = require("../../../../../UI/Button");
var _react = require("react");
var _AudienceSelectList = require("../AudienceSelectList");
var _jsxRuntime = require("react/jsx-runtime");
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var SingleStudents = function SingleStudents(props) {
  var _studentsSelectorTemp2;
  var createGroupTempData = props.createGroupTempData,
    setViewAndIndex = props.setViewAndIndex,
    studentsSelectorTempData = props.studentsSelectorTempData,
    setStudentsSelectorTempData = props.setStudentsSelectorTempData,
    setCreateGroupTempData = props.setCreateGroupTempData,
    readOnlyStudentsMapper = props.readOnlyStudentsMapper,
    environmentID = props.environmentID,
    classesIds = props.classesIds,
    groupsIds = props.groupsIds,
    singleStudentsIds = props.singleStudentsIds,
    classesMapper = props.classesMapper,
    groupsMapper = props.groupsMapper,
    getStudentsSearchList = props.getStudentsSearchList,
    _props$isEditMode = props.isEditMode,
    isEditMode = _props$isEditMode === void 0 ? false : _props$isEditMode,
    _props$isConfirmEnabl = props.isConfirmEnabled,
    isConfirmEnabled = _props$isConfirmEnabl === void 0 ? false : _props$isConfirmEnabl,
    onConfirm = props.onConfirm,
    onCancel = props.onCancel;
  var _useDeviceData = (0, _hooks.useDeviceData)(),
    isMobileView = _useDeviceData.isMobileView;
  var styles = (0, _SingleStudents.useStyles)(props);
  var getLabel = (0, _hooks.useLabels)({
    labels: _AudiencePicker.labels
  });
  var _useState = (0, _react.useState)(),
    _useState2 = _slicedToArray(_useState, 2),
    selectedOption = _useState2[0],
    setSelectedOption = _useState2[1];
  var _useState3 = (0, _react.useState)([]),
    _useState4 = _slicedToArray(_useState3, 2),
    options = _useState4[0],
    setOptions = _useState4[1];
  var handleEditGroupName = function handleEditGroupName() {
    setCreateGroupTempData(_objectSpread(_objectSpread({}, createGroupTempData), {}, {
      newGroupName: createGroupTempData === null || createGroupTempData === void 0 ? void 0 : createGroupTempData.groupName
    }));
    setViewAndIndex('createGroup', 2);
  };
  var handleSaveGroup = function handleSaveGroup() {
    var _studentsSelectorTemp;
    if (studentsSelectorTempData && (studentsSelectorTempData === null || studentsSelectorTempData === void 0 ? void 0 : (_studentsSelectorTemp = studentsSelectorTempData.selectedStudentsIds) === null || _studentsSelectorTemp === void 0 ? void 0 : _studentsSelectorTemp.length) > 0) {
      setCreateGroupTempData({
        groupName: '',
        groupId: null
      });
      setViewAndIndex('studentsSelector', 1);
    }
  };
  var handleSearchInputChange = function handleSearchInputChange(value) {
    setStudentsSelectorTempData(_objectSpread(_objectSpread({}, studentsSelectorTempData), {}, {
      studentsSearchText: value
    }));
  };
  var handleSearchInputClear = function handleSearchInputClear() {
    setStudentsSelectorTempData(_objectSpread(_objectSpread({}, studentsSelectorTempData), {}, {
      studentsSearchText: ''
    }));
  };
  var handleSearchBtnClick = function handleSearchBtnClick() {
    setStudentsSelectorTempData(_objectSpread(_objectSpread({}, studentsSelectorTempData), {}, {
      isStudentsSearchOpen: !(studentsSelectorTempData !== null && studentsSelectorTempData !== void 0 && studentsSelectorTempData.isStudentsSearchOpen)
    }));
  };
  var handleGroupsSelectChange = function handleGroupsSelectChange(option) {
    setStudentsSelectorTempData(_objectSpread(_objectSpread({}, studentsSelectorTempData), {}, {
      selectedGroup: option.value.toString(),
      isGroupSearchOpen: false
    }));
  };
  var handleStudentsSelectorTempDataChanged = function handleStudentsSelectorTempDataChanged(newSelectData) {
    setStudentsSelectorTempData(_objectSpread(_objectSpread({}, studentsSelectorTempData), {}, {
      selectedStudentsIds: _toConsumableArray(newSelectData.selectedStudentsIds || [])
    }));
  };
  (0, _react.useEffect)(function () {
    var _options = [];
    if (environmentID) {
      _options.push({
        value: 'all',
        label: getLabel('studentsSelector_groupsSelect_all')
      });
    }
    classesIds === null || classesIds === void 0 ? void 0 : classesIds.forEach(function (id) {
      if (classesMapper && classesMapper[id]) {
        var _classesMapper$id$gro;
        _options.push({
          value: id,
          label: (_classesMapper$id$gro = classesMapper[id].group) === null || _classesMapper$id$gro === void 0 ? void 0 : _classesMapper$id$gro.name
        });
      }
    });
    groupsIds === null || groupsIds === void 0 ? void 0 : groupsIds.forEach(function (id) {
      if (groupsMapper && groupsMapper[id]) {
        var _groupsMapper$id$grou;
        _options.push({
          value: id,
          label: (_groupsMapper$id$grou = groupsMapper[id].group) === null || _groupsMapper$id$grou === void 0 ? void 0 : _groupsMapper$id$grou.name
        });
      }
    });
    if (environmentID && singleStudentsIds && singleStudentsIds.length > 0) {
      _options.push({
        value: 'singleStudents',
        label: getLabel('studentsSelector_groupsSelect_singleStudents')
      });
    }
    setOptions(_options);
    setSelectedOption(_options[0]);
  }, [classesIds, classesMapper, environmentID, getLabel, groupsIds, groupsMapper, singleStudentsIds]);
  (0, _react.useEffect)(function () {
    if (studentsSelectorTempData.selectedGroup) {
      var selected = options.filter(function (option) {
        return option.value === studentsSelectorTempData.selectedGroup;
      });
      if (selected[0]) {
        setSelectedOption(selected[0]);
      }
    }
  }, [options, studentsSelectorTempData.selectedGroup]);
  var studentsList = getStudentsSearchList();
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: styles['cc-AudiencePicker__full-item'],
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Modal.Modal.Header, {
      title: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [isEditMode ? (createGroupTempData === null || createGroupTempData === void 0 ? void 0 : createGroupTempData.groupName) + ' ' : getLabel('studentsSelector_offset_title'), isEditMode ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Tooltip.Tooltip, {
          anchor: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.Button, {
            view: "alternate",
            shape: "round",
            size: "small",
            onClick: handleEditGroupName,
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
              name: "Pen",
              width: "16",
              height: "16"
            })
          }),
          children: getLabel('studentsSelector_edit_group_name_tooltip')
        }) : null]
      }),
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: styles['cc-AudiencePicker__single-students'],
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_SelectedAudience.SelectedAudience, _objectSpread(_objectSpread({}, props), {}, {
          audienceType: "students",
          onSelectedChanged: handleStudentsSelectorTempDataChanged,
          readOnlyStudentsMapper: studentsSelectorTempData && ((_studentsSelectorTemp2 = studentsSelectorTempData.selectedStudentsIds) === null || _studentsSelectorTemp2 === void 0 ? void 0 : _studentsSelectorTemp2.length) > 0 ? readOnlyStudentsMapper : [],
          selectedGroupsIds: [],
          selectedClassesIds: [],
          selectedStudentsIds: (studentsSelectorTempData === null || studentsSelectorTempData === void 0 ? void 0 : studentsSelectorTempData.selectedStudentsIds) || []
        })), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          className: styles['cc-AudiencePicker__single-students__header'],
          children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
            children: [!isMobileView && !(studentsSelectorTempData !== null && studentsSelectorTempData !== void 0 && studentsSelectorTempData.isStudentsSearchOpen) && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
              className: styles['cc-AudiencePicker__single-students__header__select-title'],
              children: getLabel('studentsSelector_groupsSelect_title')
            }), !(studentsSelectorTempData !== null && studentsSelectorTempData !== void 0 && studentsSelectorTempData.isStudentsSearchOpen) && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Select.Select, {
              id: "groupSelection",
              btnProps: {
                view: 'outlined',
                color: 'basic'
              },
              options: options,
              isFullScreen: true,
              isWithFilter: true,
              filterPlaceholder: getLabel('studentsSelector_groupsSelectPlaceholder'),
              value: selectedOption,
              onChange: handleGroupsSelectChange
            })]
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            className: styles['cc-AudiencePicker__single-students__header__search'],
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_ExpandableButton.ExpandableButton, {
              isOpen: studentsSelectorTempData === null || studentsSelectorTempData === void 0 ? void 0 : studentsSelectorTempData.isStudentsSearchOpen,
              isWithTransition: true,
              btnIconName: studentsSelectorTempData !== null && studentsSelectorTempData !== void 0 && studentsSelectorTempData.isStudentsSearchOpen ? 'ArrowBack' : 'Search',
              btnTooltip: getLabel('studentsSelector_studentsSearchPlaceholder'),
              btnProps: {
                onClick: handleSearchBtnClick,
                id: 'studentSearch',
                category: 'assignActivity',
                label: studentsSelectorTempData !== null && studentsSelectorTempData !== void 0 && studentsSelectorTempData.isStudentsSearchOpen ? 'backSearchStudentName' : 'searchStudentName'
              },
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Input.Input, {
                id: "searchByStudentName",
                type: "text",
                view: "none",
                value: studentsSelectorTempData === null || studentsSelectorTempData === void 0 ? void 0 : studentsSelectorTempData.studentsSearchText,
                placeholder: getLabel('studentsSelector_studentsSearchPlaceholder'),
                ariaLabel: getLabel('studentsSelector_studentsSearchPlaceholder'),
                width: "100%",
                onChange: handleSearchInputChange,
                isWithClearButton: Boolean(studentsSelectorTempData === null || studentsSelectorTempData === void 0 ? void 0 : studentsSelectorTempData.studentsSearchText),
                onClearButtonClick: handleSearchInputClear
              })
            })
          })]
        })]
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Modal.Modal.Content, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_AudienceSelectList.AudienceSelectList, _objectSpread(_objectSpread({}, props), {}, {
        audienceType: "students",
        searchedStudentsData: studentsList[0] && typeof studentsList[0] === 'string' ? null : studentsList,
        onSelectedChanged: handleStudentsSelectorTempDataChanged,
        studentsIds: studentsList[0] && typeof studentsList[0] === 'string' ? studentsList : studentsList.map(function (student) {
          return student.id;
        }),
        readOnlyStudentsMapper: studentsSelectorTempData !== null && studentsSelectorTempData !== void 0 && studentsSelectorTempData.selectedStudentsIds && studentsSelectorTempData.selectedStudentsIds.length > 0 ? readOnlyStudentsMapper : [],
        selectedGroupsIds: [],
        selectedClassesIds: [],
        selectedStudentsIds: (studentsSelectorTempData === null || studentsSelectorTempData === void 0 ? void 0 : studentsSelectorTempData.selectedStudentsIds) || []
      }))
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Modal.Modal.Footer, {
      justifyContent: "space-between",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Modal.Modal.Footer.Section, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.Button, {
          view: "link",
          id: "backButton",
          onClick: onCancel,
          children: getLabel('back')
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Modal.Modal.Footer.Section, {
        children: [!isEditMode && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.Button, {
          onClick: handleSaveGroup,
          id: "saveNewGroupButton",
          view: "outlined",
          isDisabled: (studentsSelectorTempData === null || studentsSelectorTempData === void 0 ? void 0 : studentsSelectorTempData.selectedStudentsIds.length) === 0,
          category: "assignActivity",
          label: "saveNewGroup",
          children: getLabel('save_as_group')
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.Button, {
          onClick: onConfirm,
          isDisabled: !isConfirmEnabled,
          id: "confirmButton",
          category: "assignActivity",
          label: "confirmSingleStudents",
          children: getLabel('confirm')
        })]
      })]
    })]
  });
};
exports.SingleStudents = SingleStudents;